
import Vue from 'vue'

import ChcInput from '@/components/Widgets/ChcInput'
import ChcMultiselectInput from '@/components/Widgets/ChcMultiselectInput'
import ChcTabControl from '@/components/Widgets/ChcTabControl'
import ChcTabPane from '@/components/Widgets/ChcTabPane'
import ChcCheckbox from '@/components/Widgets/ChcCheckbox'
import ChcLoader from '@/components/Widgets/ChcLoader'
import ChcModal from '@/components/Widgets/ChcModal'

Vue.component('ChcInput', ChcInput)
Vue.component('ChcMultiselectInput', ChcMultiselectInput)
Vue.component('ChcTabControl', ChcTabControl)
Vue.component('ChcTabPane', ChcTabPane)
Vue.component('ChcCheckbox', ChcCheckbox)
Vue.component('ChcLoader', ChcLoader)
Vue.component('ChcModal', ChcModal)



// WEBPACK FOOTER //
// ./src/components/Widgets/index.js